<div class="project-map-container">

  <agm-map
    [latitude]="mapCenterLatitude"
    [longitude]="mapCenterLongitude"
    [zoom]="zoom"
    [styles]="customGoogleMapStyle"
    [scrollwheel]="!disableScroll"
    [mapTypeControl]="true"
    [streetViewControl]="true"
    [disableDefaultUI]="true"
    [zoomControl]="true"
    (mapReady)="onMapReady($event)">


    <agm-marker
      *ngFor="let project of projects; let i = index"
      [latitude]="project.latitude"
      [iconUrl]="'./assets/images/place-marker.png'"
      [longitude]="project.longitude">

      <agm-info-window>
        <div class="project-info-window" (click)="openProjectPage(project)">
          <div>{{project.name}}</div>
        </div>
      </agm-info-window>

    </agm-marker>

  </agm-map>

</div>


